module.exports = __webpack_public_path__ + "img/violet_110.4bdca028.png";